import React, { useRef, useEffect } from 'react';
import { select, pie as d3Pie, arc as d3Arc } from 'd3';

function GaugeChart({ rejected, open, approved, width = 180, height = 120 }) {
  const ref = useRef();

  const value = rejected + open + approved;

  useEffect(() => {
    const arcData = [
      { value: rejected, color: '#E7332F' },
      { value: open, color: '#3962D4' },
      { value: approved, color: '#0E9A26' },
    ];

    select(ref.current).selectAll('*').remove();

    const svg = select(ref.current).attr('width', width).attr('height', height);

    const pieGenerator = d3Pie()
      .value((d) => d.value)
      .startAngle(-Math.PI * 0.75)
      .endAngle(Math.PI * 0.75)
      .padAngle(0.07);

    const arcs = pieGenerator(arcData);

    const arcPath = d3Arc().innerRadius(60).outerRadius(90).cornerRadius(4);

    const group = svg
      .append('g')
      .attr('transform', `translate(${width / 2},${height / 1.18})`);

    group
      .selectAll('path')
      .data(arcs)
      .enter()
      .append('path')
      .attr('d', arcPath)
      .attr('fill', (d) => d.data.color);

    // Central label
    const displayValue = value;

    svg
      .append('text')
      .attr('x', width / 2)
      .attr('y', height / 1.18 + 10)
      .attr('text-anchor', 'middle')
      .attr('font-size', '36px')
      .attr('font-weight', 'bold')
      .text(displayValue);
  }, [rejected, open, approved, value, width, height]);

  return <svg ref={ref}></svg>;
}

export default GaugeChart;
